import { Badge } from "react-bootstrap"

const STATUS_VARIANT: Record<string, string> = {
  "New": "warning",
  "Under Review": "info",
  "Resolved": "success",
}

interface Props {
  status: string
}

const IncidentStatusBadge = ({ status }: Props) => (
  <Badge bg={STATUS_VARIANT[status] ?? "secondary"}>{status}</Badge>
)

export default IncidentStatusBadge
